module.exports = __webpack_public_path__ + "img/loginbg.edad3508.jpg";